import { useState } from 'react'

import { AppBar, Tab, Tabs } from '@mui/material'
import { Link } from 'react-router-dom'

import { TabPanel } from 'components/common'
import { LegalDocumentType } from 'generated/graphql'
import { useHashToSelectTab } from 'helpers'

import { LegalDocumentView } from './LegalDocumentView'

enum TabId {
  TermsAndConditions = 0,
  PrivacyPolicy,
  CommercialTerms,
  CookiePolicy,
}

const tabsList = [
  { id: TabId.TermsAndConditions, label: 'Terms & Conditions', hash: '#terms-and-conditions' },
  { id: TabId.PrivacyPolicy, label: 'Privacy Policy', hash: '#privacy-policy' },
  { id: TabId.CommercialTerms, label: 'Commercial Terms', hash: '#commercial-terms' },
]

const primaryTab = tabsList[0]
const secondaryTabs = tabsList.filter((_, index) => index !== 0)

function commonProps(index: TabId) {
  return {
    id: `help-tab-${index}`,
    'aria-controls': `help-tabpanel-${index}`,
  }
}

const Help = () => {
  const [tabValue, setTabValue] = useState<number | false>(false)

  useHashToSelectTab(tabsList, setTabValue)

  return (
    <>
      <AppBar position='static' color='default'>
        <Tabs
          value={tabValue}
          aria-label='help tabs'
          TabIndicatorProps={{
            style: {
              transition: 'none',
            },
          }}>
          <Tab
            label={primaryTab.label}
            {...commonProps(primaryTab.id)}
            component={Link}
            to={{ hash: primaryTab.hash }}
          />
          {secondaryTabs.map((tab) => (
            <Tab
              label={tab.label}
              key={tab.id}
              {...commonProps(tab.id)}
              component={Link}
              to={{ hash: tab.hash }}
            />
          ))}
        </Tabs>
      </AppBar>

      <TabPanel value={tabValue} index={TabId.TermsAndConditions}>
        <LegalDocumentView
          documentType={LegalDocumentType.TermsAndConditions}
          fallbackTitle='Terms & Conditions'
        />
      </TabPanel>
      <TabPanel value={tabValue} index={TabId.PrivacyPolicy}>
        <LegalDocumentView
          documentType={LegalDocumentType.PrivacyPolicy}
          fallbackTitle='Privacy Policy'
        />
      </TabPanel>
      <TabPanel value={tabValue} index={TabId.CommercialTerms}>
        <LegalDocumentView
          documentType={LegalDocumentType.CommercialTerms}
          fallbackTitle='Commercial Terms'
        />
      </TabPanel>
    </>
  )
}

export default Help
